import React from 'react';

export default class ModalContent extends React.Component {
  static propTypes = {
    children: React.PropTypes.node,
    seamless: React.PropTypes.bool,
    contentClassName: React.PropTypes.string,
    containerClassName: React.PropTypes.string
  };

  render () {
    return (
      <div className={`modal__content ${this.props.containerClassName || ''}`}>
        <div
          className={`modal__content_wrapper ${this.props.contentClassName || ''}`}
          style={this.props.seamless ? {padding: 0} : {}}>
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/modal/content.js